/* global Blockly */
import React from 'react';

const BLOCK_NAME = "log";

const Log = () => {
    Blockly.Blocks[BLOCK_NAME] = {
        init: function () {
            this.appendDummyInput()
                .appendField("log to console");
            this.appendValueInput("DATA")
                .setCheck(null);
            this.setColour(Blockly.Msg.DEBUG_HUE);
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setTooltip('Logs specified block value to the console (preview mode) or error logs');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#debug-tools');
        }
    };

    Blockly.JavaScript[BLOCK_NAME] = function(block) {
        let value = Blockly.JavaScript.valueToCode(block, 'DATA', Blockly.JavaScript.ORDER_NONE);
        value = 'JSON.stringify('+value+')'
        return 'window.UtilityModule && UtilityModule.writeAppDebugLog ? UtilityModule.writeAppDebugLog("DEBUG LOG", ' + value + ') : console.log(' + value + ');\n';
    };

    return (
        <block type={BLOCK_NAME}>
            <value name={"DATA"}><shadow type={"text"}></shadow></value>
        </block>
    )
};

Log.blockName = BLOCK_NAME;

export default Log;